import React from 'react';
import {
  Box,
  Button,
  Icons,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import { createStyles } from '../../MaterialResponsive.styles';

type DeleteCommentModalProps = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({
  open,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();
  const { palette } = theme;
  const styles = createStyles(theme);

  return (
    <Modal open={open} onClose={loading ? undefined : onClose}>
      <Box sx={styles.deletePageModalDialog}>
        <Box sx={styles.deletePageModalHeader}>
          <Typography sx={styles.deletePageModalTitle}>
            Delete comment?
          </Typography>
          <IconButton
            aria-label="Close delete comment dialog"
            onClick={onClose}
            sx={styles.deletePageModalCloseButton}
            disabled={loading}
          >
            <Tooltip title="Close">
              <Icons.Close />
            </Tooltip>
          </IconButton>
        </Box>

        <Box sx={styles.deleteCommentModalBody}>
          <Typography sx={styles.deleteCommentModalBodyPrimary}>
            Are you sure you want to delete this comment?
          </Typography>
          <Typography sx={styles.deleteCommentModalBodySecondary}>
            Once deleted, it can't be recovered.
          </Typography>
        </Box>

        <Box sx={styles.deletePageModalFooter}>
          <Button
            kind="secondary"
            type="button"
            sx={{
              width: { xs: 'auto', sm: 'auto' },
              minWidth: '88px',
              height: '42px',
              minHeight: '42px',
              textTransform: 'none',
              '&.MuiButton-outlinedPrimary:hover': {
                backgroundColor: 'transparent',
                borderColor: palette?.primary?.main,
              },
            }}
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            kind="primary"
            type="button"
            sx={{
              width: { xs: 'auto', sm: 'auto' },
              minWidth: '88px',
              height: '42px',
              minHeight: '42px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: palette?.primary?.dark,
              },
            }}
            onClick={onConfirm}
            disabled={loading}
            loading={loading}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteCommentModal;
